<template>
	<div class="row dashboard">
		<div class="col-12">
			<div class="d-flex align-items-center justify-content-between mb-4">
				<h1 class="h3 mb-0 text-gray-800">
					<span v-if="$store.state.user">
						Olá,
						{{ $store.state.user.full_name }}
					</span>
				</h1>
				<b-button-group>
					<b-button variant="outline-dark" :class="range === 'weekly' ? 'active' : ''"
						@click="updateAnalytics('weekly')">
						<i class="fas fa-calendar-week"></i>
						{{ $t("Weekly") }}
					</b-button>
					<b-button variant="outline-dark" :class="range === 'monthly' ? 'active' : ''"
						@click="updateAnalytics('monthly')">
						<i class="fas fa-calendar-alt"></i>
						{{ $t("Monthly") }}
					</b-button>
					<b-button variant="outline-dark" :class="range === 'yearly' ? 'active' : ''"
						@click="updateAnalytics('yearly')">
						<i class="fas fa-calendar"></i>
						{{ $t("Yearly") }}
					</b-button>
				</b-button-group>
			</div>
			<div class="dashboard-alert-info alert-dismissible fade show" v-if="lastUpdated && showLastUpdatedAlert">
				<div class="d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center">
						<div class="alert-icon-wrapper">
							<i class="mdi mdi-clock-outline"></i>
						</div>
						<div class="alert-content">
							<strong>Dados atualizados:</strong> {{ lastUpdatedHuman }}
							<br>
							<small class="text-muted">
								<i class="mdi mdi-update"></i> Próxima atualização {{ nextUpdate }}
							</small>
						</div>
					</div>
					<button type="button" class="btn-close-custom" @click="showLastUpdatedAlert = false" aria-label="Close">
						<i class="mdi mdi-close"></i>
					</button>
				</div>
			</div>
			
			<div v-if="isRefreshing && showRefreshingAlert" class="dashboard-alert-loading alert-dismissible fade show">
				<div class="d-flex align-items-center justify-content-between">
					<div class="d-flex align-items-center">
						<div class="alert-icon-wrapper loading-icon">
							<i class="mdi mdi-loading mdi-spin"></i>
						</div>
						<div class="alert-content">
							<strong>Processando dados...</strong>
							<br>
							<small>Por favor, aguarde enquanto atualizamos suas informações</small>
						</div>
					</div>
					<button type="button" class="btn-close-custom" @click="showRefreshingAlert = false" aria-label="Close">
						<i class="mdi mdi-close"></i>
					</button>
				</div>
			</div>
		</div>
		<PostAtualizacao />
		<div class="col-md-12 mb-3 search-dashboard">
			<ResultSearchFamilia />
		</div>
		<div class="col-xl-5 col-lg-6" v-if="loading || isRefreshing">
			<div class="row">
				<div class="col-md-6 mb-3" v-for="n in 4" :key="n">
					<skeleton-widget />
				</div>
			</div>
		</div>
		<ContadorEntidade v-else :loading="loading" :report="report" container="col-xl-5 col-lg-6" />
		<div class="col-xl-7 col-lg-6">
			<skeleton-card v-if="loading || isRefreshing">
				<skeleton-text variant="title" width="60%" class="mb-3" />
				<skeleton-chart height="300px" />
			</skeleton-card>
			<area-graph v-else :loading="loading" :data="report.lista_atendimentos" titulo="Seu Histórico de Atendimentos"
				:range="range" />
		</div>
		<div class="col-md-4">
			<skeleton-card v-if="loading || isRefreshing">
				<skeleton-text variant="title" width="60%" class="mb-3" />
				<skeleton-list :count="5" />
			</skeleton-card>
			<ListAudits v-else :loading="loading" :audits="report.audits" />
		</div>
		<div class="col-md-8">
			<skeleton-card v-if="loading || isRefreshing" height="473px">
				<skeleton-text variant="title" width="60%" class="mb-3" />
				<skeleton-map height="380px" />
			</skeleton-card>
			<b-card v-else title="Mapa das Famílias Atendidas" style="min-height: 473px">
				<MapaAtendimentos :markers="mapa" />
			</b-card>
		</div>
		<div class="col-md-12">
			<Atendimentos />
		</div>
		<div class="col-md-12" v-if="$store.state.user.role_details.name != 'Nível Básico'">
			<Encaminhamentos />
		</div>
		<div class="col-md-12" v-if="
			$store.state.user.role_details.name == 'Admin' ||
			$store.state.user.role_details.name == 'Técnico(a) de Nível Médio PSE' ||
			$store.state.user.role_details.name == 'Gestor(a)' ||
			$store.state.user.role_details.name == 'TI da Unidade'
		">
			<Referencias />
		</div>
		<div class="col-md-6">
			<div class="card widget-flat">
				<loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
				<div class="card-body px-3 py-4">
					<div class="float-start mr-2">
						<i class="mdi mdi-ticket-confirmation widget-icon"></i>
					</div>
					<h3 cstyle="line-height: 30px">
						<router-link to="/dashboard/suportes">
							Minhas Solicitações de Suporte
						</router-link>
					</h3>
				</div>
				<!-- end card-body-->
			</div>
		</div>
		<div class="col-md-6">
			<div class="card widget-flat">
				<loading-animation :active.sync="loading" :is-full-page="false" :opacity="1" color="#5895ff" />
				<div class="card-body px-3 py-4">
					<div class="float-start mr-2">
						<i class="mdi mdi-headset widget-icon"></i>
					</div>
					<h3 cstyle="line-height: 30px">
						<router-link to="/dashboard/admin/central/home">
							Central de Atendimento
						</router-link>
					</h3>
				</div>
				<!-- end card-body-->
			</div>
		</div>
		<!--Modal midia-->
		<div class="modal" tabindex="-1" id="showMidia">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">
							<span class="text-uppercase">{{ midia.canal }}</span>
							-
							{{ midia.titulo }}
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12">
								<a href="#" @click="closeModal()">
									<img class="img-fluid" :src="midia.capa" :alt="midia.titulo">
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--Fim modal midia-->
	</div>
</template>
<script>
import Referencias from "./admin/painel/ListReferencia.vue";
import Encaminhamentos from "./admin/painel/ListEncaminhamentos.vue";
import Atendimentos from "./admin/painel/ListAtendimentos.vue";
import ResultSearchFamilia from "./admin/painel/ResultSearchFamilia";
import MapaAtendimentos from "./admin/painel/MapaAtendimentos";
import PostAtualizacao from "./admin/painel/PostAtualizacao";
import ContadorEntidade from "./admin/painel/ContadorEntidade";
import ListAudits from "./admin/painel/ListAudit";
import SkeletonCard from "../../../components/skeleton/SkeletonCard.vue";
import SkeletonText from "../../../components/skeleton/SkeletonText.vue";
import SkeletonChart from "../../../components/skeleton/SkeletonChart.vue";
import SkeletonList from "../../../components/skeleton/SkeletonList.vue";
import SkeletonMap from "../../../components/skeleton/SkeletonMap.vue";
import SkeletonWidget from "../../../components/skeleton/SkeletonWidget.vue";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default {
	name: "ShowMidia",
	components: {
		Atendimentos,
		Encaminhamentos,
		Referencias,
		ResultSearchFamilia,
		MapaAtendimentos,
		PostAtualizacao,
		ContadorEntidade,
		ListAudits,
		SkeletonCard,
		SkeletonText,
		SkeletonChart,
		SkeletonList,
		SkeletonMap,
		SkeletonWidget
	},
	name: "Home",
	metaInfo() {
		return {
			title: "Painel do Técnico: " + this.$store.state.user.name,
		};
	},
	mounted() {
		this.getAnalytics();
		this.getMidia();
	},
	data() {
		return {
			mapa: {},
			loading: true,
			range: "weekly",
			report: {
				audits: [],
				platforms: [],
				devices: [],
				browsers: [],
				locations: {},
				referrers: [],
				lista_atendimentos: [],
			},
			search: "",
			modal_midia: {},
			midia: {},
			isRefreshing: false,
			lastUpdated: null,
			lastUpdatedHuman: null,
			nextUpdate: null,
			showLastUpdatedAlert: true,
			showRefreshingAlert: true,
		};
	},
	methods: {
		updateAnalytics(range) {
			if (this.range !== range) {
				this.range = range;
				this.getAnalytics();
			}
		},
		getAnalytics() {
			this.loading = true;
			axios
				.get("api/analytics/report?range=" + this.range)
				.then((response) => {
					if (response.data.data.status === "refreshing") {
						this.isRefreshing = true;
					} else {
						this.isRefreshing = false;
					}

					this.loading = false;
					this.report = response.data.data.reports;
					this.mapa = response.data.data.mapa;
					this.lastUpdated = response.data.data.last_updated;
        	this.lastUpdatedHuman = response.data.data.last_updated_human;
					this.nextUpdate = response.data.data.next_update;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		getMidia() {
			axios
				.get(`api/dashboard/last/midia`)
				.then((response) => {
					this.midia = response.data;
					try {
						if (!this.midia.ciente) {
							this.midia.capa = this.gerarCapa();
							this.openModal();
						}
					} catch (error) {
						console.error(error);
					}

				})
				.finally(() => {
					this.loading = false;
					this.load = false;
				});
		},
		openModal() {
			const modalElement = document.getElementById('showMidia');
			this.modal_midia = modalElement;
			if (modalElement) {
				const modal = new bootstrap.Modal(modalElement);
				this.modal_midia = modal;
				this.modal_midia.show();
			}
		},
		closeModal() {
			const modalElement = document.getElementById('showMidia');
			this.modal_midia.hide();
			const data = {user_id: this.midia.user_id, midia_id: this.midia.id};
			axios.post(`api/dashboard/informar/leitura`, data)
				.then(response => {
					console.log('Leitura confirmada');
					window.open(this.midia.url, '_blank');
				})
				.catch(errors => {
					console.log('Ocorreu algum erro', errors);
				})
		},
		getVideoIdFromUrl(url) {
			const regExp = /(?:https?:\/\/(?:www\.)?youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
			const match = url.match(regExp);
			return match ? match[1] : null;
		},
		gerarCapa() {
			const videoId = this.getVideoIdFromUrl(this.midia.url);
			if (videoId) {
				return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
			} else {
				return null;
			}
		},
	},
};
</script>
<style>
.float-end {
	float: right !important;
}

.float-start {
	float: left !important;
}

.widget-flat {
	position: relative;
	overflow: hidden;
}

.widget-icon {
	color: #5895ff;
	font-size: 20px;
	background-color: rgba(88, 149, 255, 0.25);
	height: 30px;
	width: 30px;
	text-align: center;
	line-height: 30px;
	border-radius: 3px;
	display: inline-block;
}

.dashboard .card {
	box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%) !important;
}

.search-dashboard .input-group-text {
	background-color: #fff !important;
	border: 0px solid #e4e5e7;
	color: #808185;
	border-right: 0 !important;
	box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%) !important;
}

.search-dashboard .form-control {
	border: 0 !important;
	box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%) !important;
}

.morris-hover {
	position: absolute;
	z-index: 99 !important;
}

/** Customização da  */
@keyframes slideIn {
	0% {
		transform: translateY(-100%);
	}

	100% {
		transform: translateY(0);
	}
}

.modal-dialog {
	animation: slideIn 0.5s ease-out;
}

/* Dashboard Alerts */
.dashboard-alert-info,
.dashboard-alert-loading {
	background: linear-gradient(135deg, rgba(88, 149, 255, 0.1) 0%, rgba(88, 149, 255, 0.05) 100%);
	border-left: 4px solid #5895ff;
	border-radius: 8px;
	padding: 16px 20px;
	margin-bottom: 1rem;
	box-shadow: 0 2px 8px rgba(88, 149, 255, 0.1);
	transition: all 0.3s ease;
}

.dashboard-alert-info:hover,
.dashboard-alert-loading:hover {
	box-shadow: 0 4px 12px rgba(88, 149, 255, 0.15);
	transform: translateY(-1px);
}

.dashboard-alert-loading {
	background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 193, 7, 0.05) 100%);
	border-left-color: #ffc107;
	box-shadow: 0 2px 8px rgba(255, 193, 7, 0.1);
}

.dashboard-alert-loading:hover {
	box-shadow: 0 4px 12px rgba(255, 193, 7, 0.15);
}

.alert-icon-wrapper {
	background-color: rgba(88, 149, 255, 0.15);
	color: #5895ff;
	width: 42px;
	height: 42px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 15px;
	flex-shrink: 0;
	font-size: 20px;
	transition: all 0.3s ease;
}

.dashboard-alert-loading .alert-icon-wrapper {
	background-color: rgba(255, 193, 7, 0.15);
	color: #ffc107;
}

.alert-icon-wrapper.loading-icon {
	animation: pulse 2s infinite;
}

@keyframes pulse {
	0%, 100% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.05);
		opacity: 0.8;
	}
}

.alert-content {
	flex: 1;
	line-height: 1.6;
}

.alert-content strong {
	color: #2c3e50;
	font-size: 14px;
	font-weight: 600;
}

.alert-content small {
	font-size: 12px;
	color: #6c757d;
	display: inline-flex;
	align-items: center;
	gap: 4px;
	margin-top: 2px;
}

.btn-close-custom {
	background: transparent;
	border: none;
	color: #6c757d;
	font-size: 18px;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s ease;
	padding: 0;
	margin-left: 10px;
	flex-shrink: 0;
}

.btn-close-custom:hover {
	background-color: rgba(0, 0, 0, 0.05);
	color: #495057;
}

.btn-close-custom:active {
	transform: scale(0.95);
}

.mdi-spin {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>
